import { API_DATETIME_FMT } from "@/constants";
import { Api, TimeEntry, Equipment, Transport, Other, CompanyTransport, DrillingMachine, Material } from "@/types";
import { DateTime } from "luxon";

export function makeTimeEntry(apiTimeEntry: Api.TimeEntry): TimeEntry {
    return {
        id: apiTimeEntry.id,
        myoctans_type: apiTimeEntry.myoctans_type,
        project_id: apiTimeEntry.project_id,
        task_id: apiTimeEntry.task_id,
        is_ccq: apiTimeEntry.is_ccq,
        date_in: DateTime.fromFormat(apiTimeEntry.date_in, API_DATETIME_FMT),
        date_out: DateTime.fromFormat(apiTimeEntry.date_in, API_DATETIME_FMT),
        transport: (apiTimeEntry.ew_has_equipments ?? [])
            .filter((equipment: Api.EwHasEquipment) => equipment.category == 'personal_vehicle')
            .flatMap((equipment: Api.EwHasEquipment) => equipment.data)
            .map((transport: Api.EwHasEquipmentData) => ({
                date_in: transport?.date_in ? DateTime.fromISO(transport.date_in) : DateTime.now(),
                date_out:transport?.date_out ? DateTime.fromISO(transport.date_out) : DateTime.now(),
                departure: transport?.departure,
                arrival: transport?.arrival,
                km: transport?.km
            } as Transport)),
        lunch_time: apiTimeEntry.lunch_time ?? 0,
        break_time: apiTimeEntry.break_time ?? 0,
        lost_time: apiTimeEntry.lost_time ?? 0,
        images: apiTimeEntry.images,
        equipments: apiTimeEntry.equipment.map((equipment: Api.Equipment) => ({
            id: equipment.id,
            quantity: equipment.pivot.quantity ?? 0,
            duration: equipment.pivot.duration ?? 0
        } as Equipment)),
        others: apiTimeEntry.others.map((other: Api.Others) => ({
            name: other.name,
            quantity: other.quantity,
            price: other.price
        } as Other)),
        company_transport: apiTimeEntry.ew_has_equipments
            .filter((equipment: Api.EwHasEquipment) => equipment.category == 'vehicle')
            .map((equipment: Api.EwHasEquipment) => ({
                departure: Array.isArray(equipment.data) ? equipment.data[0].departure : equipment.data.departure,
                arrival: Array.isArray(equipment.data) ? equipment.data[0].arrival : equipment.data.arrival,
                km: Array.isArray(equipment.data) ? Number(equipment.data[0].km ?? 0) : Number(equipment.data.km),
                hours: Array.isArray(equipment.data) ? equipment.data[0].hours ?? 0 : equipment.data.hours
            } as CompanyTransport))[0],
        drilling_machines: (apiTimeEntry.ew_has_equipments ?? [])
            .filter((equipment: Api.EwHasEquipment) => equipment.category == 'drilling_machine')
            .map((drillingMachine: Api.EwHasEquipment) => ({
                id: Array.isArray(drillingMachine.data) ? drillingMachine.data[0]?.id : drillingMachine.data.id,
                equipment_id: drillingMachine.equipment_id,
                start_time: Array.isArray(drillingMachine.data) ? Number(drillingMachine.data[0]?.start_time) : Number(drillingMachine.data.start_time),
                end_time: Array.isArray(drillingMachine.data) ? Number(drillingMachine.data[0]?.end_time) : Number(drillingMachine.data.end_time),
                fuel_liters: Array.isArray(drillingMachine.data) ? Number(drillingMachine.data[0]?.fuel_liters) : Number(drillingMachine.data.fuel_liters)
            } as DrillingMachine)),
        materials: (apiTimeEntry.materials ?? []).map((material: Api.Material) => ({
            id: material.id,
            quantity: material.pivot.quantity ?? 0,
        } as Material)),
        bonuses: apiTimeEntry.bonuses.flatMap(bonus => bonus.id),
        comment: apiTimeEntry.comment ?? ''
    };
}